<template>
  <tr>
    <td>
      <v-menu offset-x open-on-hover>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            small
            color="color1"
            v-on="on"
          >
            <v-icon small>mdi-comment-eye-outline</v-icon>
          </v-btn>
        </template>
        <v-card outlined class="elevation-0">
          <v-layout class="backgroundCard pa-2 caption">
            JSON
          </v-layout>
          <div class="c-hr"></div>
          <div class="pa-3">
            <span class="caption">
              {{ item }}
            </span>
          </div>
        </v-card>
      </v-menu>
      {{ item.name }}
    </td>
    <td>
      <c-ms-ii
      :metric_definition="item.metric_definition" 
      :realValue="item.quantity"
      :key="item.inventory_item_id"
      alwaysScale
      labelMode
      ></c-ms-ii>
    </td>
    <td class="caption">
      <div>
        {{ expiryDateHuman }}
      </div>
      <div>
        {{ expiryDate }}
      </div>
      <v-chip v-if="hasExpired"
      color="pink"
      x-small
      text-color="white">
        EXPIRED
      </v-chip>
      <v-chip v-if="closeToExpiry"
      color="orange"
      x-small
      text-color="white">
        CLOSE TO EXPIRY
      </v-chip>
    </td>
  </tr>
</template>

<script>
export default {
  props: ['item'],
  computed: {
    expiryDate () {
      if (this.$moment.utc(this.item.expiry_date).isValid()) {
        return this.$moment(this.item.expiry_date).format('DD MMM YYYY')
      }
      return ''
    },
    expiryDateHuman () {
      if (this.$moment.utc(this.item.expiry_date).isValid()) {
        return this.$moment.utc(this.item.expiry_date).fromNow()
      }
      return ''
    },
    expiryFromNowInSeconds () {
      var now = this.$moment()
      var then = this.$moment(this.item.expiry_date)
      return then.diff(now, 'seconds')
    },
    expiryFromNowInMonths () {
      var now = this.$moment()
      var then = this.$moment(this.item.expiry_date)
      return then.diff(now, 'months')
    },
    hasExpired () {
      return this.expiryFromNowInSeconds < 0
    },
    closeToExpiry () {
      return this.expiryFromNowInMonths < 4 && !this.hasExpired
    },
  }
}
</script>